export default function CancellationAndRefundPolicy() {
    return (
        <div className="policy-page">
            <div className="policy-header">
                <h1>Cancellation & Refund Policy</h1>
                <p>Information about cancellations, refunds, and returns.</p>
            </div>

            <div className="policy-content">
                <h2>1. Order Cancellation</h2>
                <p>
                    Orders can be canceled within <strong>24 hours</strong> of
                    placement, provided that the order has not yet been shipped.
                </p>

                <p>
                    To request an order cancellation, please email us at{" "}
                    <a href="mailto:gorelearning.crm@gmail.com">
                        gorelearning.crm@gmail.com
                    </a>
                    .
                </p>

                <h2>2. Refund Eligibility</h2>
                <p>
                    If your product is damaged, defective, or not as described,
                    we offer a <strong>100% refund or replacement</strong>.
                </p>

                <h2>3. Return Conditions</h2>
                <p>
                    To be eligible for a return, items must meet the following
                    conditions:
                </p>

                <ul>
                    <li>Items must be unused.</li>
                    <li>Items must be returned in their original packaging.</li>
                    <li>All original tags must be included.</li>
                    <li>The original invoice must be included.</li>
                    <li>
                        Return requests must be raised within{" "}
                        <strong>3 days of delivery</strong>.
                    </li>
                </ul>

                <h2>4. Refund Processing</h2>
                <p>
                    Once the returned product is received and the refund request
                    is approved, the refund will be processed to the original
                    payment method.
                </p>

                <h2>5. Refund Timeline</h2>
                <p>
                    Approved refunds will be processed within{" "}
                    <strong>7–10 working days</strong>.
                </p>

                <h2>6. Contact</h2>
                <p>
                    For cancellation, return, or refund-related questions,
                    please contact us at:
                </p>

                <p>
                    <strong>Email:</strong>{" "}
                    <a href="mailto:gorelearning.crm@gmail.com">
                        gorelearning.crm@gmail.com
                    </a>
                </p>
            </div>
        </div>
    );
}